/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Page_DescriptionInputs */

const en_faq_page_description = /** @type {(inputs: Faq_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick answers to common questions, helping you understand products, services, or processes efficiently.`)
};

const fr_faq_page_description = /** @type {(inputs: Faq_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses rapides aux questions courantes, pour vous aider à comprendre efficacement les produits, services ou processus.`)
};

/**
* | output |
* | --- |
* | "Quick answers to common questions, helping you understand products, services, or processes efficiently." |
*
* @param {Faq_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_page_description = /** @type {((inputs?: Faq_Page_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Page_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_page_description(inputs)
	return fr_faq_page_description(inputs)
});